export * from "./angle";
export * from "./curve";
export * from "./ellipse";
export * from "./line";
export * from "./point";
export * from "./polygon";
export * from "./range";
export * from "./rectangle";
export * from "./segment";
export * from "./triangle";
export * from "./types";
export * from "./vector";
export * from "./utils";


// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyALJuovN79yJJGRuUDW6KuMiYDB53WQdR8",
  authDomain: "craftic-canvas.firebaseapp.com",
  projectId: "craftic-canvas",
  storageBucket: "craftic-canvas.firebasestorage.app",
  messagingSenderId: "516282092263",
  appId: "1:516282092263:web:0a1d0dd662fb3fe6a7b042"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
